import { useLayoutEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

/** On navigation, scroll to the linked section ("/#team") or to the top of the new page, before it paints. */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation()
  const isFirstRender = useRef(true)

  useLayoutEffect(() => {
    // The browser handles the first load, including a section in the URL.
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    const section = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null
    if (section) {
      const frame = requestAnimationFrame(() => section.scrollIntoView())
      return () => cancelAnimationFrame(frame)
    }

    const root = document.documentElement
    const previousScrollBehavior = root.style.scrollBehavior

    root.style.scrollBehavior = 'auto'
    window.scrollTo({ top: 0, left: 0 })
    root.style.scrollBehavior = previousScrollBehavior
  }, [pathname, hash])

  return null
}
